module.exports = __webpack_public_path__ + "img/mar.ia-cor.4cb3aea6.svg";